<template>
  <PlatformNavbar
    :is-not-share-page="isNotSharePage"
    :search-term="searchTerm"
    :no-editor-enabled="authData.noEditorEnabled"
    @tracking-event="handleTrackingEvent($event)"
    @update:search="handleSearch"
  />
</template>

<script setup>
import { computed, watch, onBeforeMount } from 'vue';
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';
import { useAppPlatform } from '@/stores/app/platform';
import { useTracking } from '@/stores/tracking/tracking';
import { useEditor } from '@/stores/editor/editor';
import { shareableInsights } from '@/helpers/constants/shareableInsights';
import { useFilters } from '@/stores/filters/filters';
import { useSubMenu } from '@/stores/filters/subMenu';
import { useAppAuthData } from '@/stores/app/authData';
import PlatformNavbar from '@/components/navbar/PlatformNavbar.vue';

// Router
const route = useRoute();
const router = useRouter();

// Stores
const { isSharePage } = storeToRefs(useEditor());
const { setInitFields } = useEditor();

const { authData } = storeToRefs(useAppAuthData());

const { searchTerm } = storeToRefs(useFilters());
const { submitSearchTerm } = useFilters();

const { platformInitialized } = storeToRefs(useAppPlatform()); // Check what this does
const { setPlatformCurrentJobId, initPlatform } = useAppPlatform();

const { setSelectedSubMenuOption } = useSubMenu();

// Computed
const isReportingSharePage = computed(() => shareableInsights.includes(route.name)
        && window.sessionStorage.reportingShareKey);

const isNotSharePage = computed(
  () => !(isSharePage.value || window.sessionStorage.shareKey || isReportingSharePage.value),
);

const routeJobId = computed(() => route.path.split('/')[1] === 'view' && route.params.id);

watch(
  route,
  () => {
    setPlatformCurrentJobId(routeJobId.value);
  },
);

watch(
  () => route.name,
  () => {
    if (!platformInitialized.value && !isReportingSharePage.value) {
      initPlatform(routeJobId.value, {
        setInitFieldsAction: (payload) => setInitFields(payload),
      });
    }
  },
);

onBeforeMount(() => {
  if (!isReportingSharePage.value) {
    initPlatform(routeJobId.value, {
      setInitFieldsAction: (payload) => setInitFields(payload),
    });
  }
});

// Methods
const handleTrackingEvent = ({ action, args }) => {
  useTracking()[action](args);
};

const handleSearch = (value) => {
  if (![
    'published',
    'unpublished',
    'flagship',
    'draft',
    'email',
    'draft-requisitions',
    'open-requisitions',
    'closed-requisitions',
  ].includes(route.name)) {
    router.push({ name: 'published', query: { q: value } });
    setSelectedSubMenuOption('relevance');
  } else {
    const dateSort = route.name === 'open-requisitions' ? '-opened_at' : '-closed_at';
    const defaultSort = route.name.includes('requisitions') ? dateSort : 'relevance';

    submitSearchTerm({ searchTerm: value, router, defaultSort });
  }
};
</script>
